var character = "Characters";
var copied = "Copied";
var copy = "Copy";
var insert = "Insert";
var loading = "កំពុងផ្ទុក";
var orCopyLink = "Or copy link";
var submit = "Submit";
var kmTranslations = {
	"actionPopover.delete": "Delete",
	"actionPopover.deleteNotification": "Delete this notification",
	"actionPopover.edit": "Edit",
	"actionPopover.inviteShareCommunity": "Invite / Share community",
	"actionPopover.joinCommunity": "Join Community",
	"actionPopover.leaveCommunit": "Leave Community",
	"actionPopover.leaveCommunity": "Leave Community",
	"actionPopover.leaveCommunity.accept": "Leave",
	"actionPopover.leaveCommunity.cancel": "Cancel",
	"actionPopover.leaveCommunity.description": "Are you sure you want to leave this community?",
	"actionPopover.leaveCommunity.title": "Leave Community",
	"actionPopover.report": "Report",
	"actionPopover.turnOffNotification": "Turn off notification",
	"actionPopover.turnOffNotificationAbout": "Turn off notification about {label}",
	"actionPopover.turnOnNotification": "Turn on notification",
	"adBanner.title": "ផ្សព្វផ្សាយពាណិជ្ជកម្ម",
	"admin.comments": "Comments",
	"admin.communities": "Communities",
	"admin.community": "Community",
	"article.shareOn": "Share on",
	"articleAuthor.title.expert": "Expertly reviewed by",
	"articleAuthor.title.fact-check": "ត្រួតពិនិត្យដោយ {name}",
	"articleAuthor.title.medical": "Medically reviewed by",
	"articleAuthor.title.written-by": "Written by",
	"articlePage.articleReviewerBy": "ត្រួតពិនិត្យ​ដោយ {name}",
	"articlePage.readMore": "អាន​បន្ថែម",
	"articlePage.showLess": "បង្ហាញតិច",
	"babyGrowth.alert.bmi": "There is no BMI measurements to display for {name} in WHO data range of 0 to 5 years. Use <a>BMI calculator tool</a> above 5 year old",
	"babyGrowth.alert.head": "There is no head circumference measurements to display for {name} in WHO data range of 0 to 5 years",
	"babyGrowth.alert.weight": "There is no Weight measurements to display for {name} in WHO data range of 0 to 10 years ",
	"babyGrowth.babyInfo": "ព័ត៌មានអំពីទារក",
	"babyGrowth.chartTitle": "WHO - {name} Growth Chart",
	"babyGrowth.chartTitle.noName": "តារាងវាស់វែងការលូតលាស់ទារក",
	"babyGrowth.cm": "cm",
	"babyGrowth.drawer.addMeasurement": "Add a Measurement",
	"babyGrowth.drawer.createBaby": "Create a baby profile",
	"babyGrowth.drawer.switchProfile": "Switch profile",
	"babyGrowth.emptyName": "your baby",
	"babyGrowth.error.atLeastOneOf": "Must have at least one of these fields: Weight, Height, Head Circumference (Head)",
	"babyGrowth.error.birthdayRequired": "Birthday is required",
	"babyGrowth.error.invalidAge": "The measurements exceed the age.",
	"babyGrowth.error.invalidMeasurementDate": "Measurement day is not valid.",
	"babyGrowth.error.invalidValue": "Please input a valid value",
	"babyGrowth.error.measurementDateLowerThanBirthday": "The date entered is before your child's birthday",
	"babyGrowth.error.outOfRange": "The measurements exceed the WHO's data range.",
	"babyGrowth.error.title": "Invalid data",
	"babyGrowth.head": "Head",
	"babyGrowth.headCircumference": "Head Circumference",
	"babyGrowth.height": "Height",
	"babyGrowth.input.babyName": "ឈ្មោះកូន",
	"babyGrowth.input.birthday": "Baby's birthday",
	"babyGrowth.input.bmi": "Body Mass",
	"babyGrowth.input.bodyMass": "ម៉ាសរាងកាយ",
	"babyGrowth.input.checkSubmit": "តាមដានការលូតលាស់របស់កូន",
	"babyGrowth.input.measurementDate": "កាលបរិច្ឆេទវាស់វែងតាមដាន",
	"babyGrowth.input.submit": "Track your child's growth",
	"babyGrowth.kg": "kg",
	"babyGrowth.kg.m2": "kg/m2",
	"babyGrowth.monthly": "Monthly",
	"babyGrowth.nickname": "ឈ្មោះហៅក្រៅក៏បាន",
	"babyGrowth.optional": "(optional)",
	"babyGrowth.pageTitle": "Your child's growth results",
	"babyGrowth.percentiles": "Percentiles",
	"babyGrowth.placeholder.babyName": "Add child's name",
	"babyGrowth.popup.heading": "Baby's Profile",
	"babyGrowth.reCalculate": "គណនា​ម្ដង​ទៀត",
	"babyGrowth.record": "Records",
	"babyGrowth.save": "View Growth Tracker",
	"babyGrowth.save.loggedIn": "បង្ហាញ​ពី​ការតាមដានការលូតលាស់របស់​ {name}",
	"babyGrowth.weekly": "Weekly",
	"babyGrowth.weight": "Weight",
	"babyGrowth.xLabel": "Age ({recurrence})",
	"babyGrowth.yearly": "Yearly",
	"babyPoop.findOut": "ស្វែងយល់បន្ថែម",
	"babyPoopTool.name": "Baby Poop",
	"babyVaccine.banner.readmore": "អានបន្ត",
	"babyVaccine.detail.benifit": "អត្ថប្រយោជន៍",
	"babyVaccine.detail.contraindication": "ប្រឆាំងនឹងការកំណត់",
	"babyVaccine.detail.definition": "សេចក្តីកំណត់អត្តសញ្ញាណ",
	"babyVaccine.detail.relatedArticles": "អត្ថបទពាក់ព័ន្ធ",
	"babyVaccine.immunization.vaccineName": "ឈ្មោះថ្នាំបង្ការ",
	"babyVaccine.immunization.warning": "ប៉ាម៉ាក់ងាយស្រួល​យល់ពី​តួលេខចាក់ថ្នាំបង្ការ ព្រោះ​វា​ស្រដៀង​គ្នា​ទៅ​នឹង​តារាង​ពេល​វេលាចាក់​ថ្នាំ​បង្ការ​កូនៗ​លោក​អ្នក​ដែរ",
	"babyVaccine.popup.button": "Create a new profile",
	"babyVaccine.popup.button.submit": "រក្សាទុក",
	"babyVaccine.popup.checkbox.suggestedDate": "ជ្រើស​រើស​កាល​បរិច្ឆេទដែល​ត្រូវ​ចាក់​វ៉ាក់​សាំង ឬ​រក្សា​កាល​បរិច្ឆេទ​ដែលត្រូវ​បានផ្តល់​ឲ្យ នៅ​ខាងក្រោមនេះ",
	"babyVaccine.popup.confirm.close": "ប្ដូរកាលបរិច្ឆេទ",
	"babyVaccine.popup.confirm.description": "កូនរបស់លោកអ្នកបាន​ចាក់ថ្នាំបង្ការនេះរួចហើយ​កាលពី{date}",
	"babyVaccine.popup.confirm.ok": "បញ្ជាក់",
	"babyVaccine.popup.confirm.title": "កាលបរិច្ឆេទចាក់ថ្នាំបង្ការ",
	"babyVaccine.popup.input.suggestedDate": "ខ្ញុំភ្លេច/សូមជួយណែនាំ",
	"babyVaccine.popup.label.doses": "ចំនួនដូស",
	"babyVaccine.popup.tab.benefits": "អត្ថប្រយោជន៍",
	"babyVaccine.popup.tab.contraindication": "ប្រឆាំងឬប្រើប្រាស់មិនបាន",
	"babyVaccine.popup.tab.detail": "លម្អិត",
	"babyVaccine.popup.tab.schedule": "តាមដាន",
	"babyVaccine.popup.title": "ព័ត៌មានថ្នាំបង្ការ",
	"babyVaccine.status.all": "ទាំងអស់",
	"babyVaccine.status.missed": "ខកខាន",
	"babyVaccine.status.next": "Next",
	"babyVaccine.status.upcoming": "បន្ទាប់",
	"babyVaccine.status.vaccinated": "ទទួលវ៉ាក់សាំងរួច",
	"babyVaccine.timeline.antigen": "អង់ទីហ្សែន",
	"babyVaccine.timeline.atBirth": "ទើបកើត",
	"babyVaccine.timeline.total": "សរុប {number} ដូស",
	"babyVaccine.timeline.totalNext": "បន្ទាប់់ {number} ដូស",
	"babyVaccine.timeline.totalPast": "កាលពីមុន {number} ដូស",
	"babyVaccine.vaccineCard.injected": "ចាក់រួច",
	"babyVaccine.vaccineCard.markAsInjected": "សម្គាល់ថាបានចាក់រួច",
	"babyVaccine.vaccineInfo.dose": "ដូស: {ordinal}/{total}",
	"babyVaccine.vaccineInfo.injectedDate": "កាលបរិច្ឆេទចាក់: {date}",
	"babyVaccine.vaccineInfo.mandatory": "ចាំបាច់",
	"babyVaccine.vaccineInfo.optional": "ជម្រើស",
	"babyVaccine.vaccineInfo.suggested": "កាលបរិច្ឆេទណែនាំ: {date}",
	"babyVaccineTool.heading": "តារាងកាលវិភាគចាក់ថ្នាំបង្ការ(វ៉ាក់សាំង) ទារក",
	"bmi.ageInput": "អ្នកអាយុប៉ុន្មានហើយ?",
	"bmi.ageInput.desc": "(ឆ្នាំ)",
	"bmi.ageInput.error": "សូមបញ្ចូលអាយុឲ្យបានត្រឹមត្រូវ",
	"bmi.heading": "គណនា BMI",
	"bmi.heightInput": "អ្នកកម្ពស់ប៉ុន្មាន? ",
	"bmi.heightInput.desc": "(សង់ទីម៉ែត្រ)",
	"bmi.heightInput.error": "សូមបញ្ចូលកម្ពស់ឲ្យបានត្រឹមត្រូវ",
	"bmi.objective": "គោលបំណង",
	"bmi.objective.gainWeight": "យក​សាច់ដុំ",
	"bmi.objective.loseWeight": "ស្រកទម្ងន់ រំលាយ​ខ្លាញ់",
	"bmi.objective.maintainWeight": "រក្សាទម្ងន់",
	"bmi.result.healthy": "គីឡូគ្រប់ល្អ",
	"bmi.result.overweight": "លើសគីឡូ",
	"bmi.result.underweight": "មិនគ្រប់គីឡូ",
	"bmi.selectGender": "អ្នកភេទអ្វីដែរ?",
	"bmi.submit": "គណនា",
	"bmi.weightInput": "អ្នកគីឡូប៉ុន្មាន? ",
	"bmi.weightInput.desc": "(គីឡូក្រាម)",
	"bmi.weightInput.error": "សូមបញ្ចូលទម្ងន់ឲ្យបានត្រឹមត្រូវ",
	"bmr.heading": "គណនា BMR ",
	"booking.searchBar.allLocations": "ទីតាំងទាំងអស់",
	"booking.searchBar.allSpecialties": "គ្រឿងសម្រាប់ទាំងអស់",
	"booking.searchBar.currentLocation": "Current location",
	"booking.searchBar.grantLocation": "Please grant location permission to search by current location",
	"booking.searchBar.locationPlaceholder": "Enter city",
	"booking.searchBar.noResults": "No Results",
	"booking.searchBar.placeholder.doctor": "Search by doctor name",
	"booking.searchBar.placeholder.hospital": "Search by hospital name",
	"booking.searchBar.placeholder.service": "Search by service",
	"booking.searchBar.placeholder.specialty": "Search by specialty",
	"booking.searchBar.popularKey": "គ្រឿងសាទុស្រុក",
	"booking.searchBar.searchButton": "Search",
	"booking.searchBar.searchInput.placeholder": "Search by Specialty or Clinic...",
	"booking.searchBar.useCurrentLocation": "Use my current location",
	"booking.searchBar.viewAll": "មើលទាំងអស់",
	"booking.searchPopup.doctors": "Doctors",
	"booking.searchPopup.hospitals": "Hospitals & Clinics",
	"booking.searchPopup.searchIn.doctors": "Search \"{name}\" in Doctors",
	"booking.searchPopup.searchIn.hospitals": "Search \"{name}\" in Hospitals",
	"booking.searchPopup.searchIn.services": "See \"{name}\" in Services",
	"booking.searchPopup.searchIn.specialties": "Search \"{name}\" in Specialties",
	"booking.searchPopup.seeAll": "See All",
	"booking.searchPopup.seeLessSpecialties": "See less specialties",
	"booking.searchPopup.seeMoreSpecialties": "See more specialties",
	"booking.searchPopup.services": "Services",
	"booking.searchPopup.specialties": "Specialties",
	"booking.searchResult.description": "{search_type} នៅ {search_location}",
	"bottomBar.share": "Share",
	"cardAuthor.admin": "Admin",
	"cardAuthor.ambassador": "Ambassador",
	"cardAuthor.expert": "Expert",
	"cardAuthor.guide": "Guide",
	"cardAuthor.influencer": "Influencer",
	"cardAuthor.localAdmin": "Local Admin",
	"cardAuthor.moderator": "Moderator",
	"cardAuthor.sponsor": "Sponsor",
	"cardPost.anonymous": "Anonymous",
	"cardPost.option.anonymous": "អនាមិក",
	"cardPost.public": "សាធារណៈ",
	"cardReactions.comment": "Comment",
	"cardReactions.like": "Like",
	"cardReactions.repliesCount": "{count} replies",
	"cardReactions.reply": "Reply",
	"cardReactions.save": "Save",
	"cardReactions.unSave": "Unsave",
	"cardReply.disclaimer": "<strong>Disclaimer:</strong> The content is furnished relying on authenticated information sources.",
	"cardReply.endorse": "Endorse",
	"cardReply.opposePopup.content": "Can you please provide the reasons for refuting this answer?",
	"cardReply.opposePopup.submit": "Submit",
	"cardReply.pppose": "Refute",
	"cardReply.recommentCategories.heading": "Related content",
	"cardReply.source": "Sources",
	"cardReply.verifyBy": "Medically reviewed by {name}",
	"careBooking.bookAnAppointment": "ណាត់ជួបឬកក់ពេទ្យ",
	"categoryPage.info.reviewed": "ត្រួតពិនិត្យវេជ្ជសាស្ត្រដោយ",
	"categoryPage.onDate": "នៅ {date}",
	character: character,
	"chatbot.with.me": "Chat with me",
	"childCard.age.months": "{month}ខែ",
	"childCard.age.oneMonth": "1 month",
	"childCard.age.oneWeek": "1 week",
	"childCard.age.oneYear": "1 year",
	"childCard.age.oneYearMonth": "1 year {month} months",
	"childCard.age.oneYearOneMonth": "1 year 1 month",
	"childCard.age.week": "{weeks} សប្ដាហ៍",
	"childCard.age.yearMonth": "{year} years {month} months",
	"childCard.age.yearNoMonth": "{year} ឆ្នាំ",
	"childCard.age.yearOneMonth": "{year} years 1 month",
	"childCard.boy": "ប្រុស",
	"childCard.girl": "ស្រី",
	"childCard.menu.add": "Add a child profile",
	"childCard.menu.edit": "Edit {name}’s profile",
	"childCard.menu.remove": "Remove {name}’s profile",
	"childCard.menu.switch": "Switch child's profile",
	"childCard.noName": "Child's Name",
	"choicePopover.ambassadorPosts": "Ambassador posts",
	"choicePopover.expertPosts": "Expert posts",
	"choicePopover.lastestPost": "Latest posts",
	"choicePopover.latest": "Latest",
	"choicePopover.newest": "Newest",
	"choicePopover.oldest": "Oldest",
	"choicePopover.popular": "Popular",
	"choicePopover.popularPost": "Popular posts",
	"choicePopover.sort": "Sort",
	"choose.community": "Choose your community",
	"choose.other.community": "Choose another community",
	"chooseBaby.button": "View your Child Growth Chart",
	"chooseBaby.new": "or Add new child profile",
	"chooseBaby.placeholder": "Please give child's name",
	"chooseBaby.title": "Choose Child's Profile",
	"comment.count": "{count} comments",
	"comment.now": "Comment now",
	"comment.seeMoreComments": "See {count} more comments",
	"comment.seeMoreReplies": "See {count} more replies",
	"commentPopup.warning.newPost": "មតិរបស់អ្នកនឹងបង្ហាញជាសាធារណៈ",
	"common.playing": "ដំណើរការ...",
	"common.profileNavigator.newsletterSubscription": "Newsletter Subscription",
	"common.sponsoredBy": "គាំទ្រដោយ",
	"common.totalView": "{number} ដងការមើល",
	"community.choose": "Choose a community",
	"community.notification.joined": "You joined {name} community",
	"community.notification.left": "You left {name} community",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "សួរវេជ្ជបណ្ឌិត",
	"createPost.askDoctor.description": "សូមទទួលបានការប្រឹក្សាពីអ្នកជំនាញរបស់យើង",
	"createPost.askDoctorChoice.no": "No",
	"createPost.askDoctorChoice.yes": "Yes",
	"createPost.communityAndTopic": "សហគមន៍ និង ប្រធានបទ",
	"createPost.message.askDoctorRequire": "Would you like to ask a question to our doctor?",
	"createPost.message.askDoctorRequireMess": "សូមជ្រើសរើសជម្រើសមួយ",
	"createPost.message.lengthDescription": "ពណ៌នាត្រូវមានយ៉ាងហោចណាស់ 10 ពាក្យ",
	"createPost.message.lengthTitle": "The title must be at least 5 words",
	"createPost.message.lengthTitle.characters": "The title must be at least 5 characters long.",
	"createPost.message.photoMaxium": "អនុញ្ញាតតែរូបភាពច្រើនបំផុត 10 រូបពេលផ្ទុកឡើងសម្រាប់ប្រកាស",
	"createPost.message.photoSize": "អនុញ្ញាតតែផ្ទុកឡើងនូវរូបភាពទំហំ <= 10 MB",
	"createPost.message.requiredDescription": "ត្រូវការពណ៌នា",
	"createPost.message.requiredTitle": "ចំណងជើងគឺចាំបាច់",
	"createPost.message.suggestLoading": "We are suggesting relevant communities for your post",
	"createPost.message.suggestResult": "You can post now! We will continue to find relevant communities right after that",
	"createPost.now": "Post now",
	"createPost.photos": "រូបថត",
	"createPost.popup.description": "Description",
	"createPost.popup.guideSelectMonthTopics": "Choose topics about your baby's birth month",
	"createPost.popup.guideSelectTopics": "Choose topics, where to post your articles",
	"createPost.popup.primary": "Tap to select/ unselect topics",
	"createPost.popup.selectMonthTopicBtn": "Select",
	"createPost.popup.specialCharErr": "The title you entered is invalid. Titles must contain letters.\n",
	"createPost.popup.submit": "Post",
	"createPost.popup.success": "New Post Created",
	"createPost.popup.warning": "Select a community to see your following topics",
	"createPost.popup.warningImage": "Maximum 20 images allow, please remove some item below",
	"createPost.popup.wordCount": "{count}/{max} words",
	"createPost.post.askDoctor.description": "Describe symptoms",
	"createPost.post.askDoctor.title": "Symptom name",
	"createPost.post.description": "Post description",
	"createPost.post.title": "Post title",
	"createPost.postAnonymous": "Post Anonymously",
	"createPost.title": "Title",
	"createPost.urlText": "Text",
	"createPost.video": "វីដេអូ",
	"createPost.videoOrLink": "វីដេអូ ឬ តំណភ្ជាប់",
	"dueDatePage.IUI": "ការបញ្ចូលទឹកកាមក្នុងស្បូន (IUI)",
	"dueDatePage.calculationMethod": "វិធីសាស្ត្រគណនា",
	"dueDatePage.conceptionDate": "ថ្ងៃ​បង្ក​កំណើត",
	"dueDatePage.date_of_IUI_procedure": "កាលបរិច្ឆេទនៃនីតិវិធី IUI",
	"dueDatePage.date_of_ultrasound": "កាលបរិច្ឆេទនៃអ៊ុលត្រាសោន",
	"dueDatePage.daysText": "{number} ចំំនួន​ថ្ងៃ​",
	"dueDatePage.ivf": "ការ​បង្កកំណើត​ក្នុង​កែវ(IVF)",
	"dueDatePage.ivf.transferDate": "កាលបរិច្ឆេទនៃការផ្សាំអំប្រ៊ីយ៉ុង",
	"dueDatePage.ivf.transferDateRadio": "{number} ថ្ងៃផ្សាំអំប្រ៊ីយ៉ុង",
	"dueDatePage.lastPeriod": "ការ​មក​រដូវចុងក្រោយ",
	"dueDatePage.lastPeriod.calculate": "គណនា",
	"dueDatePage.lastPeriod.lastPeriodLabel": "ថ្ងៃដំបូង​បំផុត​នៃ​ការ​មក​រដូវចុងក្រោយ",
	"dueDatePage.lastPeriod.periodLengthLabel": "រយៈពេល​វដ្ដរដូវ",
	"dueDatePage.ultrasound": "Ultrasound",
	"dueDatePage.ultrasound.tooltip": "Mean sac Diameter (MSD) is less accurate than Crown-Rump Length (CRL) for dating a pregnancy. It is only used in very early pregnancy, between 4 and 6 weeks.",
	"dueDatePage.validation.crl": "តម្លៃ MSD មិនត្រឹមត្រូវទេ។ សូមបញ្ចូលសន្ទស្សន៍ CRL ដើម្បីបន្ត។",
	"dueDatePage.validation.one_is_required": "យ៉ាងហោចណាស់តម្រូវឱ្យមានមួយ",
	"dueDatePage.validation.record_not_valid": "Your recorded isn't valid!",
	"editor.addSocialLink.addLink": "បន្ថែម",
	"editor.addSocialLink.warningDomain": "អនុញ្ញាតតែប្រភពពី Youtube, Facebook, និង Tiktok",
	"expert.content.description": "អំពី​គ្រូពេទ្យឯកទេស",
	"expert.content.experiences": "Experiences",
	"footer.signUp": "ចុះឈ្មោះ​ឥឡូវ​នេះ",
	"gender.boy": "ប្រុស",
	"gender.female": "ស្រី",
	"gender.girl": "ស្រី",
	"gender.male": "ប្រុស",
	"healthToolPNModal.back": "Back",
	"healthToolPNModal.findMore.chooseFav": "Choose from your favorite topics\n",
	"healthToolPNModal.finish": "Finish",
	"healthToolPNModal.heading": "Nhận bản tin miễn phí mỗi tuần?",
	"healthToolPNModal.mainForm.requireName": "Please enter your name",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "These topics are tailored to your result",
	"healthToolPNModal.next": "Next",
	"healthToolPNModal.register": "Register",
	"healthToolPNModal.yourPre": "Your preferences",
	"healthTools.dueDateCalculator": "គណនាថ្ងៃសម្រាលកូន",
	"healthTools.ovulationCalculator": "គណនាថ្ងៃមេជីវិតញីទុំធ្លាក់",
	"healthtool.placeholder.age": "អាយុរបស់អ្នក",
	"home.calcWithApp": "Calculate on Hello Bacsi app",
	"home.menu.category.view": "បើក {category}",
	"home.navigator.app": "App",
	"home.navigator.downloadApp": "Download App",
	"home.navigator.menu.care.homeButton": "Booking Home",
	"home.navigator.menu.care.noDatas.cta": "Book a Doctor",
	"home.navigator.menu.care.noDatas.description": "HelloCare helps patients to find the right medical doctors and service treatment for their needs, in their vicinity.",
	"home.navigator.menu.care.noDatas.title": "Make an appointment with doctors easily",
	"home.navigator.menu.category.noDatas.cta": "Discover now",
	"home.navigator.menu.category.noDatas.description": "Hello គ្រូពេទ្យ ​ចង់​ក្លាយ​ជា​ប្រភព​ជិតស្និទ្ធបំផុតដើម្បី​ផ្ដល់​ព័ត៌មាន​ដ៏​ត្រឹមត្រូវ​ ដើម្បី​ជា​ទុន​ក្នុង​ការ​សម្រេច​ចិត្ត ធ្វើ​យ៉ាង​ណា​ឲ្យ​បងប្អូន​រស់នៅ​ប្រកប​ដោយ​សុខភាព​ល្អ​បរិបូរណ៍ និង​ស្រស់ស្រាយ​សុខសប្បាយ​ជា​ដរាប",
	"home.navigator.menu.category.noDatas.title": "Hello គ្រូពេទ្យ ",
	"home.navigator.menu.healthTools.noDatas.cta": "Discover more",
	"home.navigator.menu.healthTools.noDatas.description": "These easy-to-use health assessment tools will help you gauge vital parts of your overall health and wellness.",
	"home.navigator.menu.healthTools.noDatas.title": "Health Tools",
	"home.navigator.menu.lastestVideos": "វីដេអូខ្លីថ្មីបំផុត",
	"home.navigator.menu.podcasts": "ផតខាស",
	"home.navigator.menu.shorts": "វីដេអូខ្លី",
	"home.navigator.menu.spotlightEcom": "Categories",
	"home.navigator.menu.spotlightHospitals": "Popular Hospitals",
	"home.navigator.menu.spotlightTools": "Favorite Tools",
	"home.navigator.menu.spotlights": "មាតិកាពិសេស​ទាំងអស់",
	"home.navigator.menu.spotlights.seeAll": "មើល​មាតិកាពិសេស​ទាំងអស់",
	"home.navigator.menu.together.noPosts.cta": "Join Our Communities",
	"home.navigator.menu.together.noPosts.description": "Community is a safe space where you can connect with other members, comment on topics you care about, and receive trusted advice from medical experts on the health issues that matter most.",
	"home.navigator.menu.together.noPosts.title": "Welcome to Community",
	"home.navigator.menu.trendingPosts": "Highlight Posts",
	"home.navigator.menu.trendingPosts.seeMore": "មើល​បន្ថែម",
	"home.navigator.menu.videos": "វីដេអូច្រើន",
	"home.navigator.menuItem.allCategories": "មើល​គ្រប់​ផ្នែក​ទាំង​អស់",
	"home.navigator.menuItem.allCommunities": "បង្ហាញសហគមន៍ទាំងអស់",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "Find your communities",
	"home.navigator.menuItem.allHealthTools": "មើល​ផ្នែក​​រង្វាស់​សុខភាពទាំង​អស់",
	"home.navigator.menuItem.allSpecialties": "All specialties",
	"home.navigator.menuItem.allSpotlight": "មើល​មាតិកាពិសេស​ទាំងអស់",
	"home.navigator.menuItem.allVideos": "See All Videos",
	"home.navigator.menuItem.discover": "មាតិកា",
	"home.navigator.menuItem.healthCategories": "មាតិកា",
	"home.navigator.menuItem.healthTools": "រង្វាស់​សុខភាព",
	"home.navigator.menuItem.healthToolsList": "ឧបករណ៍សុខភាព",
	"home.navigator.menuItem.helloCare": "ការ​ព្រួយបារម្ភ",
	"home.navigator.menuItem.helloEcom": "eShop",
	"home.navigator.menuItem.helloTogether": "សហគមន៍",
	"home.navigator.menuItem.language": "ភាសា",
	"home.navigator.menuItem.new": "new",
	"home.navigator.menuItem.specialties": "Specialties",
	"home.navigator.menuItem.spotlights": "មាតិកាពិសេស​ទាំងអស់",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Video Categories",
	"home.search": "ស្វែងរក {site}",
	"home.seeAll": "មើល​ទាំង​អស់",
	"home.seeAllCategories": "អត្ថបទ​ទាំង​អស់",
	"home.seeExpert": "បង្ហាញ​ព័ត៌មានគ្រូពេទ្យឯកទេសបន្ថែម​",
	"home.seeHospital": "បង្ហាញ​ព័ត៌មានមន្ទីរពេទ្យបន្ថែម​",
	"home.seeMore": "អានបន្ត",
	"home.seeMoreExperts": "មើល​បន្ថែម​ពី​គ្រូពេទ្យ​ឯកទេស",
	"hospital.content.description": "Hospital Details",
	"inputComment.replyTo": "Reply to {name}",
	insert: insert,
	"label.latestPost": "Latest Post",
	"label.pinnedPost": "Pinned Post",
	"lead.empty.cancel": "លុប​ចោល",
	"lead.empty.submitAgain": "ដាក់ស្នើម្ដងទៀត",
	"lead.empty.title": "អូុបស! ហាក់ដូចជាព័ត៌មានរបស់អ្នកទទេ។ តើអ្នកចង់ដាក់ស្នើព័ត៌មានម្តងទៀតទេ?",
	"leadgen.message.error.name_required": "Please enter your name",
	"leadgen.message.error.phone_invalid": "Please enter a valid phone number",
	loading: loading,
	"login.booking": "ណាត់ជាមួយវេជ្ជបណ្ឌិត",
	"logout.popup.ask.mb": "Logout of Marry Baby",
	"logout.popup.ask1": "ចង់ចាកចេញពី Hellokrupet? ",
	"logout.popup.ask2": "ប្រាកដហើយ​ថា អ្នក​ចង់​ចាកចេញ? ",
	"logout.popup.button.cancel": "ទេ! អត់ទេ",
	"logout.popup.button.logout": "ចាកចេញ",
	"menu.care.searchBySpecialties": "Search by specialty",
	"morePopover.report": "Report",
	"morePopover.report.description": "Help us understand what’s happening with this post. How would you describe it?",
	"morePopover.report.falseNews": "False news",
	"morePopover.report.offensive": "Offensive",
	"morePopover.report.other": "Other",
	"morePopover.report.prohibited": "Prohibited content",
	"morePopover.report.scam": "Misleading or scam",
	"morePopover.report.sex": "Sexually inappropriate",
	"morePopover.report.spam": "Spam",
	"morePopover.report.title": "Report this post",
	"morePopover.report.violence": "Violence",
	"morePopover.reportSubmit.description": "We won’t tell them who reported it. Please check these details:",
	"morePopover.reportSubmit.title": "Submit report?",
	"morePopover.savePost": "Save post",
	"morePopover.share": "Share",
	"morePopover.shareOn": "Share on",
	"morePopover.turnOffNotifications": "Turn off notifications",
	"morePopover.turnOnNotifications": "Turn on notifications",
	"morePopover.unsavePost": "Remove Saved post",
	"navigation.loginJoin": "ចូល",
	"navigation.search.input.placeholder": "Search",
	"navigation.signUp": "Sign up",
	"newsletter.error.minCotennt": "Please select at least 1 topic to continue this action",
	"newsletter.error.minTitle": "Minimum 1 topics reached",
	"newsletter.topic.title": "What health topics are you interested in?",
	"newsletter.welcome.description": "តើ​លោក​អ្នក​​ចង់​ប្រើឈ្មោះ​អ្វី?",
	"notification.comment.blocked.message": "This comment contains banned words or phrases and won’t be published",
	"notification.comment.blocked.title": "Blocked comment",
	"notification.comment.premod": "មតិរបស់អ្នក​ត្រូវ​ឆ្លងកាត់ការត្រួតពិនិត្យមុនបង្ហាញ",
	"notification.comment.rejected": "មតិរបស់អ្នក​មានពាក្យពេចន៍​មិន​សមគួរ ដែលមិនអនុញ្ញាតឲ្យបង្ហាញបាន",
	"notification.comment.reportFailed": "បរាជ័យ!",
	"notification.comment.reportSuccess": "អ្នកបាន​រាយការណ៍​ពី​មតិមិនសមគួរ​ជោគជ័យហើយ",
	"notification.comment.somethingWrong": "មានបញ្ហា",
	"notification.comment.suspect.message": "This comment contains suspected words or phrases and won’t be published",
	"notification.comment.suspect.title": "Pending comment",
	"notification.comment.systemWithheld": "មតិរបស់អ្នក​ត្រូវ​ឆ្លងកាត់ការត្រួតពិនិត្យមុនបង្ហាញ",
	"notification.failure": "Something wrong. Try again later!",
	"notification.limitUrlDomain": "Cannot post link outside of Hello Health Group.",
	"notification.post.blocked.message": "This post contains banned words or phrases and won’t be published",
	"notification.post.blocked.title": "Blocked post",
	"notification.post.delete": "Post Deleted",
	"notification.post.suspect.message": "This post contains suspected words or phrases, and is placed for moderator review",
	"notification.post.suspect.title": "Pending post",
	"notification.success": "Success",
	"notification.suspend.message": "Your account has been suspended for violating our terms of service",
	"notification.urlWrongFormat": "Incorrect URL format",
	"onboarding.button.continue": "បន្ត",
	"onboarding.button.skip": "រំលង",
	"onboarding.errorMessage.invalidEmail": "អុីម៉ែល​ គ្មានសុពល​ភាព",
	"onboarding.errorMessage.minLength": "សូម​បំពេញយ៉ាង​ហោច​ណាស់ {} ខ្ទង់",
	"onboarding.errorMessage.passNotMatch": "លេខសម្ងាត់់ត្រូវ​តែ​ដូច​គ្នា",
	"onboarding.errorMessage.passWithPattern": "លេខ​សម្ងាត់់​ត្រូវ​តែ​​តួមាន​ទាំង​អក្សធំ និង​តូច",
	"onboarding.errorMessage.requiredConfirmPassword": "សូម​បញ្ជាក់​លេខ​សម្ងាត់​របស់​អ្នក",
	"onboarding.errorMessage.requiredEmail": "សូម​បំពេញ​អុីម៉ែល​របស់​អ្នក",
	"onboarding.errorMessage.requiredName": "សូម​បំពេញ​ឈ្មោះ​របស់​​អ្នក​",
	"onboarding.errorMessage.requiredPassword": "សូម​បំំពេញ​ពាក្យ​សម្ងាត់​របស់​អ្នក",
	"onboarding.formEmail.description": "បន្ត​ជា​មួយ​នឹង​អុី​ម៉ែល​​របស់​លោក​អ្នក ដើម្បី​បន្ត​ជាមួយ​នឹង​សហគមន៍ {site}",
	"onboarding.formEmail.genderFemale": "ស្រី",
	"onboarding.formEmail.genderMale": "ប្រុស",
	"onboarding.formEmail.heading": "សូម​​ឲ្យយើង​ស្គាល់​អ្នក​កាន់​តែ​ច្បាស់",
	"onboarding.formEmail.yourBirthday": "ថ្ងៃ​ខែ​ឆ្នាំ​កំណើត",
	"onboarding.formEmail.yourEmail": "អុីម៉ែល​របស់​អ្នក",
	"onboarding.formEmail.yourName": "ឈ្មោះ​របស់​អ្នក",
	"onboarding.label.fullName": "Full name",
	"onboarding.otpForm.description": "យើង​បាន​ផ្ញើរ​លេខ​សម្ងាត់ (OTP) ទៅ​លេខ​ទូរ​ស័ព្ទ​លោក​អ្នក​រួច​​ហើយ",
	"onboarding.otpForm.descriptionEmail": "យើង​បាន​ផ្ញើរលេខសម្ងាត់ (OTP) ទៅ​កាន់​អុីម៉ែល​របស់​​អ្នក​ហើយ",
	"onboarding.otpForm.error": "សូមបំំពេញ​លេខ​ OTP ដែលមាន​សុពល​ភាព",
	"onboarding.otpForm.heading": "បញ្ចូល​លេង​សម្ងាត់ OTP របស់​អ្នក",
	"onboarding.otpForm.notReceiveOTP": "មិន​បាន​ទទួល​លេខ​សម្ងាត់ OTP ឬ?",
	"onboarding.otpForm.resendCode": "ផ្ញើកូដឡើងវិញ",
	"onboarding.otpForm.resendCodeWithSeconds": "ផ្ញើរ​លេខ​កូដម្តង​ទៀត {seconds}",
	"onboarding.otpWhatsapps.description": "យើងបានផ្ញើលេខសម្ងាត់អាចត្រូវបានចេញទៅលេខទូរស័ព្ទ WhatsApp {phone} របស់អ្នក។",
	"onboarding.otpWhatsapps.heading": "ការធានារ៉ាប់ WhatsApp",
	"onboarding.similac.address.error": "Your address is required",
	"onboarding.similac.input.address": "Your address",
	"onboarding.similac.input.city": "Please select your city/province",
	"onboarding.similac.input.district": "Please select your district/town",
	"onboarding.similac.input.no": "Please enter your street name, building, house no.",
	"onboarding.similac.input.phone": "Your phone number",
	"onboarding.similac.input.ward": "Please select your ward/village",
	"onboarding.updatePassword.confirmPassword": "បញ្ជាក់លេខសម្ងាត់",
	"onboarding.updatePassword.description": "លេខសម្ងាត់​របស់​អ្នក​ត្រូវ​តែ​មាន​ចាប់​ពី​៨ខ្ទង់​ឡើង​​ទៅ",
	"onboarding.updatePassword.heading": "ជិត​សម្រេចហើយ! អ្នកត្រូវ​ការ​លេខ​សម្ងាត់",
	"onboarding.updatePassword.password": "លេខ​សម្ងាត់",
	"onboarding.updatePasswordResult.description": "ពេល​នេះ លោក​អ្នក​ចូល​​ទៅកាន់​គណនី Hellokrupet ជាមួយនឹង​លេខ​សម្ងាត់​ថ្មីនេះ​បានហើយ​។​",
	"onboarding.updatePasswordResult.heading": "ការ​បង្កើត​លេខ​សម្ងាត់​ទទួល​បាន​ជោគ​ជ័យ",
	"onboarding.updatePhone.description": "យើង​នឹង​ផ្ញើរ​លេខ​សម្ងាត់​មួយ (OTP) ទៅ​កាន់​លេខទូរស័ព្ទ​របស់​លោក​អ្នក",
	"onboarding.updatePhone.error": "សូមបំពេញលេខ​ទូរស័ព្ទដែលមានសុពល​ភាព",
	"onboarding.updatePhone.heading": "លេខ​ទូរ​ស័ព្ទ​របស់​លោក​អ្នក",
	"onboarding.updateWhatsapp.description": "Whatsapp នឹងត្រូវការអ៊ីនធឺណតតូចរបស់អ្នក។",
	"onboarding.updateWhatsapp.submitLabel": "បន្តទំនុកចុះឈ្មោះជាមួយ WhatsApp",
	"onboarding.welcomeScreen.content": "បើក និងស្វាគមន៍​មកកាន់​កន្លែង​ដែល​លោក​អ្នក​​អាច​ចែក​​រំលែក ភ្ជាប់ទំនាក់ទំនង និង​គាំទ្រ​គ្នា​ទៅ​វិញ​ទៅមក​ជាមួយ​នឹង​សមា​ជិក​ផ្សេង​ទៀត ដើម្បី​​ទទួល​បាន​ការ​ស់​ប្រកប​ដោយ​សុខភាព និង​សុភមង្គល។ ",
	"onboarding.welcomeScreen.heading": "សូម​ស្វាគមន៍​មក​កាន់​សហ​គមន៍ Hellokrupet",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "ចៀសវាងការមានផ្ទៃពោះ",
	"ovulationPage.conceive": "ព្យាយាមយកកូន",
	"ovulationPage.cycleLength": "រយៈពេល​វដ្ដរដូវ",
	"ovulationPage.dayUnit": "ថ្ងៃ",
	"ovulationPage.objectives": "គោលបំណង",
	"ovulationPage.periodDuration": "វដ្ដរដូវ",
	"ovulationPage.trackPeriod": "តាមដានវដ្ដរដូវ",
	"placeholder.enterTitleHere": "Enter title here",
	"placeholder.enterUrlHere": "Enter URL here",
	"placeholder.enterUrlTextHere": "Enter URL Text here",
	"placeholder.newCmt": "Write a comment",
	"placeholder.newPost": "Start a new post",
	"pnBanner.both": "Both",
	"pnBanner.both.desc": "Welcome to the adventure of parenthood! Choose a tool that suit you.",
	"pnBanner.both.heading": "Experience our tools for parent!",
	"pnBanner.caclNow": "Calculate now",
	"pnBanner.checkNow": "Check now!",
	"pnBanner.dueDateTool.desc": "Plan ahead for the big day with a stress-free experience!",
	"pnBanner.dueDateTool.heading": "Try our Due Date Calculator",
	"pnBanner.hpv.desc": "Your response helps us craft recommendations specific to your family's needs.",
	"pnBanner.hpv.heading": "Keep your girl safe from HPV virus!",
	"pnBanner.parenting.desc": "Your response helps us craft recommendations specific to your family's needs. ",
	"pnBanner.parenting.heading": "What is the age range of your kids?",
	"pnBanner.pn.btnLabel": "Premium Newsletter",
	"pnBanner.pregnancy.desc": "Input this to ensure our recommendations suits your exciting new journey.",
	"pnBanner.pregnancy.heading": "Are you navigating the world of pregnancy?",
	"pnBanner.submit": "Submit",
	"pnBanner.teenager": "Teenager",
	"pnBanner.teenager.heading": "What is the gender of your kids?",
	"pnBanner.toddlers": "Toddlers",
	"pnBanner.vaccination.desc": "Keep your little one protected with customized vaccination schedules!",
	"pnBanner.vaccination.heading": "Try our Baby Vaccine Scheduler",
	"pnBanner.vaccine.btnLabel": "Baby Vaccine Scheduler",
	"pnModal.disclaimer": "Your first email digest is on its way. Get excited to dive into content that’s tailored specifically for you!",
	"pnTopicSection.maxSelectError.desc": "Remove at least 1 selected topic to continue this action",
	"pnTopicSection.maxSelectError.detail": "Choose maximum {max} topics ({maxTopic})",
	"pnTopicSection.maxSelectError.title": "Maximum {maxSelect} topics reached",
	"pnTopicSection.notFound": "Nothing found",
	"pnTopicSection.plsEnterFavTopics": "Please enter your favorite topics",
	"pnTopicSection.ppAlsoInterested": "People are also interested",
	"pnTopicSection.recentView": "Recently viewed",
	"pnTopicSection.trending": "Trending",
	"popup.allTopics": "All Topics",
	"popup.createPost.confirmCloseDescription": "If you discard now, you’ll lose this post",
	"popup.createPost.confirmCloseTitle": "Are you sure?",
	"popup.deleteComment.description": "Delete your comment cannot be undone",
	"popup.deleteComment.title": "Delete comment?",
	"popup.deletePost.accept": "Delete",
	"popup.deletePost.cancel": "Cancel",
	"popup.deletePost.description": "Delete your post cannot be undone",
	"popup.deletePost.title": "Delete post?",
	"popup.discardPost": "Discard post",
	"popup.discardPostEdit": "Discard changes",
	"popup.editPost": "Edit post",
	"popup.keepEditing": "Keep editing",
	"popup.startANewPost": "Start a new post",
	"post.commentCount": "{count} comments",
	"post.likesCount": "{count} likes",
	"post.remove.failed": "លុបបរាជ័យ",
	"post.remove.success": "បានលុបប្រកាសបានរក្សាទុក",
	"post.save.failed": "ការរក្សាទុកប្រកាសបរាជ័យ",
	"post.save.success": "បានរក្សាទុកប្រកាស",
	"post.seeMore": "See more",
	"post.shareCount": "{count} shares",
	"pregnancy.week": "សប្ដាហ៍",
	"pregnancyTool.description": "កូនរបស់អ្នកមានទំហំប៉ុន <fruitName>",
	"pregnancyTool.title": "ចំនួនសប្តាហ៍នៃការមានផ្ទៃពោះ",
	"pregnancyTool.weightSuggested": "ទម្ងន់ដែលត្រូវបានណែនាំ",
	"pregnancyWeightGain.havingTwins": "តើលោកអ្នកកំពុងមានកូនភ្លោះមែនទេ?",
	"pregnancyWeightGain.heading": "ការឡើងទម្ងន់ស្ត្រីអំឡុងពពោះ",
	"pregnancyWeightGain.heightInput": "ចុះកម្ពស់វិញប៉ុន្មានដែរ? ",
	"pregnancyWeightGain.weekInput": "ពពោះបានប៉ុន្មានសប្ដាហ៍ហើយ?",
	"pregnancyWeightGain.weightBeforeInput": "តើទម្ងន់របស់អ្នកមុនមានផ្ទៃពោះប៉ុន្មានគីឡូដែរ?",
	"pregnancyWeightGain.weightInput": "ចុះឥឡូវទម្ងន់ប៉ុន្មាន(គីឡូក្រាម)ហើយ?",
	"pregnancyWeightGain.weightInput.desc": "(គីឡូក្រាម)",
	"pregnancyWeightGain.weightInput.error": "សូមបញ្ចូល​ទម្ងន់​ឲ្យ​បានត្រឹមត្រូវ",
	"previewPhotos.title": "{name}'s Post",
	"profilePanel.anserwing.viewFull": "View full answers",
	"profilePanel.awards": "Awards & Accreditations",
	"profilePanel.createPost": "Create post",
	"profilePanel.education": "Education",
	"profilePanel.emptyCareMess.content": "It looks like there are currently no questions for the doctor at this time. Thank you for being a part of our community.",
	"profilePanel.emptyPostMess.content": "{name} has not been engaged in any activities lately.",
	"profilePanel.experience": "Experiences",
	"profilePanel.joined": "Joined",
	"profilePanel.modal.heading": "Profile",
	"profilePanel.publishcation": "Publications",
	"profilePanel.publishedArticles": "Pulished article on Hello Bacsi",
	"profilePanel.question": "Question",
	"profilePanel.questionNotClear": "Question isn't clear",
	"profilePanel.skipQuestion.content": "We will remove this question from your list",
	"profilePanel.skipQuestion.heading": "Skip this question",
	"profilePanel.socialLinks": "Social Links",
	"profilePanel.tabs.care": "Care",
	"profilePanel.tabs.expertAnswer": "Expert Answering",
	"profilePanel.tabs.highlight": "Credentials & Highlights",
	"profilePanel.tabs.posts": "Posts",
	"profilePanel.tabs.relevantArticles": "Relevant Articles",
	"pwg.placeholder.height": "កម្ពស់(សង់ទីម៉ែត្រ)",
	"pwg.placeholder.weight": "ទម្ងន់(គីឡូក្រាម)",
	"pwgForm.week": "សប្តាហ៍",
	"sensitiveMask.blur": "ធ្វើឲ្យព្រាល",
	"sensitiveMask.contentWarningDescription": "ការព្រមាន៖ រូបភាពខាងក្រោម​អាចមិនល្អ អាចធ្វើឲ្យអ្នកមានអារម្មណ៍​មិនល្អខ្ពើមរអើម។ ដូច្នេះសូមជូនជាដំណឹងមុនបើកបង្ហាញ។ អរគុណ! ",
	"sensitiveMask.contentWarningDescription.community": "Warning: The image may be disturbing.",
	"sensitiveMask.contentWarningMessage": "រូបភាពទាំងនេះប្រហែលជាមានបញ្ហា ...",
	"sensitiveMask.unblur": "បង្ហាញ",
	"share.by": "ចែករំលែកតាម",
	"share.copyLink": "Or copy link",
	"share.letsJoinCommunity": "Let's join {name} community!",
	"share.letsJoinTopic": "Let's join {name} topic!",
	"share.linkCopied": "Link Copied",
	"share.linkShared": "Link Shared Successfully",
	"share.title": "Share",
	"shareContainer.title": "ចែករំលែកលទ្ធផល",
	"similac.thankYou.done": "Done",
	"ssov2.abTestingFlowB.description": "Sign up or log in with your email or social media account.",
	"ssov2.button.cancel": "Cancel",
	"ssov2.button.continue": "Continue",
	"ssov2.button.continueGoogle": "Continue with Google",
	"ssov2.button.continueSMS": "Continue with SMS",
	"ssov2.button.continueWhatsApp": "Continue with WhatsApp",
	"ssov2.button.continueZalo": "Continue with Zalo",
	"ssov2.button.exitNow": "I want to exit now",
	"ssov2.button.otp.sms": "Send OTP Code via SMS",
	"ssov2.button.otp.whatsapp": "Send OTP Code via WhatsApp",
	"ssov2.button.otp.zalo": "Send OTP Code via Zalo",
	"ssov2.button.save": "Save",
	"ssov2.button.setupLater": "Setup later",
	"ssov2.collectInfo.why": "Why We Need Your Information?",
	"ssov2.email.alreadyUsed": "Email này đã được sử dụng, vui lòng chọn Email khác.",
	"ssov2.email.button": "Verify Your Email",
	"ssov2.email.description": "Use your email to continue login or register",
	"ssov2.email.title": "Continue with email",
	"ssov2.error.api": "API error",
	"ssov2.error.api.000": "Some Things Went Wrong",
	"ssov2.error.api.001": "The email must be a valid email address.",
	"ssov2.error.api.002": "The email field is required.",
	"ssov2.error.api.003": "This member is not exist yet",
	"ssov2.error.api.004": "The email may not be greater than 255 characters.",
	"ssov2.error.api.005": "The phone number field is required.",
	"ssov2.error.api.006": "The phone number must be at least 9 characters.",
	"ssov2.error.api.007": "This phone number is already linked to your profile",
	"ssov2.error.api.008": "The otp code field is required.",
	"ssov2.error.api.009": "User don't update",
	"ssov2.error.api.010": "Verify OTP failed",
	"ssov2.error.api.011": "The name must be a string.",
	"ssov2.error.api.012": "The name may not be greater than 100 characters.",
	"ssov2.error.api.013": "The username must be a string.",
	"ssov2.error.api.014": "The username has already been taken.",
	"ssov2.error.api.015": "The username may not be greater than 20 characters.",
	"ssov2.error.api.016": "The birthday does not match the format Y-m-d.",
	"ssov2.error.api.017": "The avatar field is required.",
	"ssov2.error.api.018": "The avatar must be an image.",
	"ssov2.error.api.019": "The avatar must be a file of type: jpeg, jpg, png, gif.",
	"ssov2.error.api.020": "The avatar may not be greater than 10240 kilobytes.",
	"ssov2.error.api.021": "The confirm-password field is required.",
	"ssov2.error.api.022": "The confirm-password must be at least 8 characters.",
	"ssov2.error.api.023": "The confirm-password format is invalid.",
	"ssov2.error.api.024": "The confirm-password may not be greater than 50 characters.",
	"ssov2.error.api.025": "The new-password field is required.",
	"ssov2.error.api.026": "The new-password must be at least 8 characters.",
	"ssov2.error.api.027": "The new-password format is invalid.",
	"ssov2.error.api.028": "The new-password may not be greater than 50 characters.",
	"ssov2.error.api.029": "Your password doesn't match. Please try again.",
	"ssov2.error.api.030": "Your new password must be different from the current one",
	"ssov2.error.api.031": "The new password field is required.",
	"ssov2.error.api.032": "The confirm new password field is required.",
	"ssov2.error.api.033": "The new password and confirm new password must match.",
	"ssov2.error.api.034": "The confirm new password must be at least 8 characters.",
	"ssov2.error.api.035": "The new password must be at least 8 characters.",
	"ssov2.error.api.036": "The confirm new password may not be greater than 50 characters.",
	"ssov2.error.api.037": "The new password may not be greater than 50 characters.",
	"ssov2.error.api.038": "The current password is wrong!",
	"ssov2.error.api.039": "The password field is required.",
	"ssov2.error.api.040": "Token Signature could not be verified.",
	"ssov2.error.api.041": "Token has expired",
	"ssov2.error.api.042": "The refresh token field is required.",
	"ssov2.error.api.043": "The area code field is required.",
	"ssov2.error.api.044": "The email has already been taken.",
	"ssov2.error.api.045": "Verify Email OTP Code Fail",
	"ssov2.error.api.046": "The code field is required.",
	"ssov2.error.api.047": "The phone number has already been taken.",
	"ssov2.error.api.048": "The Phone is not match phone number that you registered",
	"ssov2.error.api.049": "User was exist",
	"ssov2.error.api.050": "The website id field is required.",
	"ssov2.error.api.051": "The name field is required.",
	"ssov2.error.api.052": "The birthday field is required.",
	"ssov2.error.api.053": "The gender field is required.",
	"ssov2.error.api.054": "The provider field is required.",
	"ssov2.error.api.055": "The token field is required.",
	"ssov2.error.api.056": "Code has been sent to your email",
	"ssov2.error.api.057": "The email does not exist.",
	"ssov2.error.api.058": "You are verifying a phone number that is not yours",
	"ssov2.error.api.059": "The selected phone number is invalid.",
	"ssov2.error.api.060": "Phone does not member",
	"ssov2.error.api.061": "This phone number is already linked to your profile",
	"ssov2.error.api.062": "Error ZNS with missing msg_id",
	"ssov2.error.api.063": "OTP verify missing",
	"ssov2.error.api.064": "The expire at must be a date after 5 mins.",
	"ssov2.error.api.065": "The selected code is invalid.",
	"ssov2.error.api.066": "Error when update ZNS tracking",
	"ssov2.error.api.067": "Sent Zalo OTP failed",
	"ssov2.error.api.068": "The expire at must be a date after 10 mins.",
	"ssov2.error.api.069": "The code must be at least 6 characters.",
	"ssov2.error.api.070": "The code may not be greater than 10 characters.",
	"ssov2.error.api.071": "You’ve reached the limit of 3 verification attempts in 1 hour. Please wait and try again later.",
	"ssov2.error.api.072": "You’ve reached the limit of 5 verification attempts today. Please try again tomorrow.",
	"ssov2.error.api.073": "The password must be at least 8 characters.",
	"ssov2.error.api.074": "The password format is invalid.",
	"ssov2.error.api.075": "The confirm-password format is invalid.",
	"ssov2.error.api.076": "The password must contain at least one number.",
	"ssov2.error.api.077": "The confirm-password must contain at least one number.",
	"ssov2.error.api.078": "The email was exist",
	"ssov2.error.api.079": "Too many messages",
	"ssov2.error.api.080": "The selected otp code is invalid",
	"ssov2.error.api.082": "The password must contain at least one uppercase and one lowercase letter.",
	"ssov2.error.api.083": "Sent Whatsapp OTP failed",
	"ssov2.error.facebookLogin": "Facebook login failed",
	"ssov2.error.googleLogin": "Error login with Google",
	"ssov2.first.country.code": "Country Code",
	"ssov2.first.description": "Continue with your phone number, email or your socials to log in or sign up.",
	"ssov2.first.noAccountOrPass": "You have no account or need to setup password, please continue register",
	"ssov2.first.search.country.all": "All Countries",
	"ssov2.first.search.country.placeholder": "Search country/region",
	"ssov2.first.search.country.selected": "Current selection",
	"ssov2.first.title.login": "Log In",
	"ssov2.first.title.signup": "Sign Up",
	"ssov2.orContinueWith": "Or continue with",
	"ssov2.otp.email.description": "Enter the 6-digit OTP sent to your email <b>{email}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.email.title": "Verify Email",
	"ssov2.otp.phone.description": "Enter the 6-digit OTP sent to the phone number <b>{phone}</b> via <b>{method}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.phone.title": "Verify Phone Number",
	"ssov2.otp.resendQuestion": "Didn’t receive the code?",
	"ssov2.otp.resendText": "Resend ({count}s)",
	"ssov2.otp.sendVia": "Send OTP Code via {method}",
	"ssov2.password.description": "Đăng nhập bằng mật khẩu của bạn.",
	"ssov2.password.forgotPassword": "Forgot Password?",
	"ssov2.password.reset": "Reset",
	"ssov2.password.signIn": "Sign In",
	"ssov2.password.title1": "Welcome back!",
	"ssov2.password.title2": "Enter your password",
	"ssov2.passwordForgotSetup.description": "Set up your login password and other details to complete the registration process.",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "At least 8 characters.",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "At least one uppercase letter, one lowercase letter, and one number.",
	"ssov2.passwordForgotSetup.field.password.label": "Password",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Input your password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Confirm Password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Confirm Password",
	"ssov2.passwordForgotSetup.title": "Setup your password",
	"ssov2.phone.alreadyUsed": "Phone number is already used, please use another phone number",
	"ssov2.phoneVerify.description": "Please provide additional information to complete the account registration process.",
	"ssov2.phoneVerify.title": "Verify Phone Number",
	"ssov2.policyText": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.community": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree to join the community of HelloDoctor, and I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.privacy": "Privacy Policy",
	"ssov2.policyText.terms": "Terms of Service",
	"ssov2.popup.close.description": "You’re just a step away from completing your account setup. Do you really want to leave?",
	"ssov2.popup.close.title": "Are you sure you want to exit?",
	"ssov2.resetPassword.description": "Please provide the phone number you used to create your account.",
	"ssov2.resetPassword.title": "Reset password",
	"ssov2.setup.button.createAccount": "Create new account",
	"ssov2.setup.button.veriyPhone": "Verify Phone Number",
	"ssov2.setup.description": "Please provide additional information to complete the account registration process.",
	"ssov2.setup.field.dob.label": "Birthday",
	"ssov2.setup.field.dob.placeholder": "Enter your birthday",
	"ssov2.setup.field.email.label": "Email",
	"ssov2.setup.field.gender.female": "Female",
	"ssov2.setup.field.gender.label": "Gender",
	"ssov2.setup.field.gender.male": "Male",
	"ssov2.setup.field.name.label": "Name",
	"ssov2.setup.field.name.placeholder": "Enter your name",
	"ssov2.setup.field.otp.label": "Receive OTP Via",
	"ssov2.setup.field.phone.label": "Phone number",
	"ssov2.setup.title": "Almost done!",
	"ssov2.updateEmail.button": "Verify Your Email",
	"ssov2.updateEmail.description": "Please update and verify your email to continue using our services.",
	"ssov2.updateEmail.title": "Update Your Email",
	"ssov2.useOtherMethod.email": "This account has not enabled login with an email. Please choose another login method.",
	"ssov2.useOtherMethod.phone": "This account has not enabled login with a phone number. Please choose another login method.",
	"ssov2.validate.confirmPassword.match": "Passwords must match",
	"ssov2.validate.confirmPassword.required": "Confirm password is required",
	"ssov2.validate.dob.required": "Date of birth is required",
	"ssov2.validate.email.invalid": "Invalid email",
	"ssov2.validate.email.required": "Email is required",
	"ssov2.validate.gender.oneOf": "Gender must be male or female",
	"ssov2.validate.gender.required": "Gender is required",
	"ssov2.validate.name.required": "Name is required",
	"ssov2.validate.otp.required": "OTP method is required",
	"ssov2.validate.password.required": "Password is required",
	"ssov2.validate.phone.required": "Phone number is required",
	submit: submit,
	"switchBtn.no": "ទេ",
	"switchBtn.yes": "បាទ/ចាស",
	"tab.about": "About",
	"tab.discussion": "Discussions",
	"tab.topic": "Topics",
	"tagTopic.moreTopics": "{number} more topics",
	"targetHearRate.heading": "រង្វាស់ចង្វាក់បេះដូង",
	"targetHeartRate.aerobicZone.note": "ហាត់បែប​អែរ៉ូបិក កម្រិតបង្គួរ (៣ - ៥ថ្ងៃ/សប្ដាហ៍)",
	"targetHeartRate.aerobicZone.title": "ហាត់បែប​អែរ៉ូបិក កម្រិតបង្គួរ",
	"targetHeartRate.ageInput": "ថ្ងៃខែឆ្នាំកំណើត",
	"targetHeartRate.ageInput.desc": "(ឆ្នាំ)",
	"targetHeartRate.ageInput.error": "សូមបញ្ចូលអាយុ​ឲ្យ​បាន​ត្រឹមត្រូវ",
	"targetHeartRate.heartRateInput": "អត្រាបេះដូងលោតពេលសម្រាក របស់អ្នក​ចំនួន​ប៉ុន្មានដែរ?",
	"targetHeartRate.heartRateInput.desc": "(ដង/នាទី)",
	"targetHeartRate.heartRateInput.error": "សូមបញ្ចូលចំនួន​ \"អត្រាបេះដូងលោតពេលសម្រាក\" ​ឲ្យ​បាន​ត្រឹមត្រូវ",
	"targetHeartRate.lowIntensity.note": "ហាត់តិចណាស់ (ឬ​មិនហាត់សោះតែម្ដង)",
	"targetHeartRate.lowIntensity.title": "ហាត់តិចតួច",
	"targetHeartRate.maximumIntensity.note": "សកម្មខ្លាំង (ហាត់លើស​អ្នក​ធម្មតា x ២)",
	"targetHeartRate.maximumIntensity.title": "សកម្មខ្លាំង",
	"targetHeartRate.moderateIntensity.note": "ហាត់កម្រិត​មធ្យម (១ - ៣ថ្ងៃ/សប្ដាហ៍)",
	"targetHeartRate.moderateIntensity.title": "ហាត់កម្រិតមធ្យម",
	"targetHeartRate.optional": "(បំពេញក៏បាន រំលងក៏បាន)",
	"targetHeartRate.selectActive": "រាល់ថ្ងៃ​តើ​អ្នក​សកម្មរាងកាយ ឬ​ហាត់ប្រាណ​ប៉ុណ្ណាដែរ? ",
	"targetHeartRate.vigorousIntensity.note": "ហាត់សកម្ម( ៦ - ៧ថ្ងៃ/សប្ដាហ៍)",
	"targetHeartRate.vigorousIntensity.title": "ហាត់សកម្ម",
	"tool.askChecking": "កំពុងស្វែងរកផ្សេងពីនេះ",
	"tool.selectPerson": "អ្នក​ពិនិត្យ​ឲ្យ​អ្នក​ណាដែរ? ",
	"tool.selectPerson.other": "អ្នកផ្សេង",
	"tool.selectPerson.yourSelf": "ខ្លួនឯង",
	"toolPage.toolReviewer": "ត្រួតពិនិត្យដោយ  {expert_name} នៅ​ {date}",
	"tools.checkYourKidsInput.label": "តើអ្នកកំពុងពិនិត្យសម្រាប់កូនរបស់អ្នកឬ?",
	"tools.checkYrs": "តើ​អ្នក​កំពុង​ពិនិត្យ​សម្រាប់​អ្នក​ខ្លះ​ឫ?",
	"tools.heading.on": "នៅលើ",
	"tools.heartRateRangeErr": "សូមបញ្ចូលតម្លៃក្នុងចន្លោះ {min} - {max} bpm",
	"tools.inputPlaceholder": "ឧទាហរណ៍: {content}",
	"tools.requiredErrorMess.age": "សូមបញ្ចូលអាយុឲ្យបានត្រឹមត្រូវ",
	"tools.requiredErrorMess.gender": "សូមបញ្ចូលភេទ",
	"tools.selectBabyGender": "កូនប្រុសឬស្រី?",
	"tools.selectGender": "អ្នកភេទអ្វីដែរ?",
	"tools.yearsOld": "ឆ្នាំ",
	"updatePost.popup.success": "The post has been updated successfully.",
	"userProfile.nav.card.eCom": "eShop",
	"userProfile.nav.card.ecom.DeliveryAddress": "Manage addresses",
	"userProfile.nav.card.ecom.manageOrders": "Manage orders",
	"userProfile.nav.card.ecom.voucher": "Voucher",
	"userProfile.nav.card.myBooking": "ការណាត់ជួបរបស់ខ្ញុំ",
	"userProfile.nav.card.myCommunity": "សហគមន៍របស់ខ្ញុំ",
	"userProfile.nav.card.myFamily": "ប្រវត្តិរូបសមាជិកគ្រួសារ",
	"userProfile.nav.card.myHealth": "សុខភាពរបស់ខ្ញុំ",
	"userProfile.nav.card.mySaved": "រក្សាទុក",
	"userProfile.nav.header.count.comments": "មតិ",
	"userProfile.nav.header.count.posts": "ការបង្ហោះ",
	"userProfile.nav.header.count.tools": "រង្វាស់សុខភាព",
	"userProfile.nav.header.points": "ពិន្ទុ",
	"userProfile.nav.header.viewProfile": "មើលប្រវត្តិរូបរបស់ខ្ញុំ",
	"userProfile.nav.menu.accountSettings": "ការកំណត់គណនី",
	"userProfile.nav.menu.dataPrivacy": "ទិន្នន័យឯកជនភាព",
	"userProfile.nav.menu.disableAccount": "ផ្អាកដំណើរការគណនី",
	"userProfile.nav.menu.help": "ជំនួយ",
	"userProfile.nav.menu.logout": "ចាកចេញ",
	"userProfile.nav.menu.password": "លេខសម្ងាត់",
	"userProfile.userRank.ambassador": "ទូតសុឆន្ទៈ",
	"userProfile.userRank.doctor": "វេជ្ជបណ្ឌិត",
	"userProfile.userRank.expert": "អ្នកជំនាញ",
	"userProfile.userRank.influencer": "Influencer",
	"userProfile.userRank.member": "សមាជិ",
	"validation.error.requiredAgeGroup": "Your child is not in the required age group",
	"validation.error.requiredField": "ព័ត៌មាន​ចាំបាច់​ដែល​ត្រូវ​បំពេញ",
	"verifyBotAnswer.confirmEndorse.accept": "Yes, endorse",
	"verifyBotAnswer.confirmEndorse.cancel": "No, cancel",
	"verifyBotAnswer.confirmEndorse.description": "Thank you for endorsing the answer",
	"verifyBotAnswer.confirmEndorse.heading": "Endorse this answer"
};

export { character, copied, copy, kmTranslations as default, insert, loading, orCopyLink, submit };
